var map = {
	"./additionalInfoIcon.svg": 684,
	"./arrowBottomIconSharpSmall.svg": 685,
	"./arrowLeftIcon.svg": 686,
	"./arrowMediumTop.svg": 687,
	"./arrowRightIcon.svg": 688,
	"./arrowRightIconSharp.svg": 689,
	"./arrowRightSmallIcon.svg": 690,
	"./arrowScalableIcon.svg": 691,
	"./arrowSelect2.svg": 692,
	"./arrowSelectIcon.svg": 693,
	"./benefit1.svg": 694,
	"./benefit2.svg": 695,
	"./benefit3.svg": 696,
	"./cardsIcon.svg": 697,
	"./circleInfoIcon.svg": 698,
	"./copyIcon copy.svg": 699,
	"./copyIcon.svg": 700,
	"./crossIcon.svg": 701,
	"./crossIcon2.svg": 702,
	"./crossIcon3.svg": 703,
	"./crossIconSmall.svg": 704,
	"./crossSmallIcon.svg": 705,
	"./defaultCategoryIcon.svg": 706,
	"./depNumberIcon.svg": 707,
	"./elfCentralIcon.svg": 708,
	"./errorIcon.svg": 709,
	"./eyeClosedIcon.svg": 710,
	"./eyeOpenIcon.svg": 711,
	"./favoritesIcon.svg": 712,
	"./favoritesLabelIcon.svg": 713,
	"./filterDivider.svg": 714,
	"./filterIcon.svg": 715,
	"./frequencyIcon.svg": 716,
	"./fsAmountIcon.svg": 717,
	"./fullScreenIcon.svg": 718,
	"./gameIcon.svg": 719,
	"./gemIcon.svg": 720,
	"./goldGiftIcon.svg": 721,
	"./hamburgerIcon.svg": 722,
	"./infoIcon.svg": 723,
	"./infoIconSmall.svg": 724,
	"./infoSymbol.svg": 725,
	"./levelBackground.svg": 726,
	"./levelBackgroundNew.svg": 727,
	"./linkIcon.svg": 728,
	"./lockIcon.svg": 729,
	"./lockSharpIcon.svg": 730,
	"./maxBonusAmountIcon.svg": 731,
	"./maxWinFsIcon.svg": 732,
	"./menu/bonusShopIcon.svg": 457,
	"./menu/fortuneIcon.svg": 458,
	"./menu/fortuneIconL.svg": 459,
	"./menu/helpdeskIcon.svg": 460,
	"./menu/helpdeskIconL.svg": 461,
	"./menu/homeIcon.svg": 462,
	"./menu/homeIconLarge.svg": 463,
	"./menu/jackpotIcon.svg": 464,
	"./menu/logo.svg": 465,
	"./menu/logoSmall.svg": 466,
	"./menu/lotteryIcon.svg": 467,
	"./menu/loyaltyIcon.svg": 468,
	"./menu/mobileAppIcon.svg": 469,
	"./menu/profileIcon.svg": 470,
	"./menu/questIcon.svg": 471,
	"./menu/questsIcon.svg": 472,
	"./menu/rewardLineupIcon.svg": 473,
	"./menu/searchIcon.svg": 474,
	"./menu/searchIconLarge.svg": 475,
	"./menu/signOutIcon.svg": 476,
	"./menu/star.svg": 477,
	"./menu/tournamentIcon.svg": 478,
	"./menu/tournamentLargeIcon.svg": 479,
	"./menu/vipIcon.svg": 480,
	"./menu/wheelIcon.svg": 481,
	"./menu/wheelIconL.svg": 482,
	"./menu/wheelIconMobile.svg": 483,
	"./menuIcon.svg": 733,
	"./minDepIcon.svg": 734,
	"./minusIcon.svg": 735,
	"./noTournamentIcon.svg": 736,
	"./numbers/number-1.svg": 484,
	"./numbers/number-2.svg": 485,
	"./numbers/number-3.svg": 486,
	"./numbers/number-4.svg": 487,
	"./numbers/number-5.svg": 488,
	"./numbers/number-6.svg": 489,
	"./numbers/number-7.svg": 490,
	"./numbers/number-8.svg": 491,
	"./numbers/number-9.svg": 492,
	"./numbers/number-shine-1.svg": 493,
	"./numbers/number-shine-2.svg": 494,
	"./numbers/number-shine-3.svg": 495,
	"./numbers/number-shine-4.svg": 496,
	"./numbers/number-shine-5.svg": 497,
	"./numbers/number-shine-6.svg": 498,
	"./numbers/number-shine-7.svg": 499,
	"./numbers/number-shine-8.svg": 500,
	"./numbers/number-shine-9.svg": 501,
	"./playIcon.svg": 737,
	"./plusIcon.svg": 738,
	"./polygon.svg": 739,
	"./preloaderDotsAnimation.svg": 740,
	"./preloaderSpinnerAnimation.svg": 741,
	"./present2Icon.svg": 742,
	"./presentIcon.svg": 743,
	"./promoIcon.svg": 744,
	"./recentIcon.svg": 745,
	"./search2Icon.svg": 746,
	"./search3Icon.svg": 747,
	"./sharpTickIcon copy.svg": 748,
	"./sharpTickIcon.svg": 749,
	"./smallInfoSymbol.svg": 750,
	"./smoothArrowIcon.svg": 751,
	"./successIcon.svg": 752,
	"./supportIcon.svg": 753,
	"./tag1Icon.svg": 754,
	"./tag2Icon.svg": 755,
	"./tag3Icon.svg": 756,
	"./tag4Icon.svg": 757,
	"./tickIcon.svg": 758,
	"./unverified.svg": 759,
	"./verified.svg": 760,
	"./wagerIcon.svg": 761,
	"./wagerTimeIcon.svg": 762,
	"./warningIcon.svg": 763,
	"./zoomIcon.svg": 764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 683;